"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.haulingStatisticTypes = void 0;
exports.haulingStatisticTypes = {
    SET_ERROR: 'HAULING STATISTIC TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'HAULING STATISTIC TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'HAULING STATISTIC TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'HAULING STATISTIC TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'HAULING STATISTIC TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'HAULING STATISTIC TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'HAULING STATISTIC TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'HAULING STATISTIC TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'HAULING STATISTIC TYPES SET SUCCESS MODAL',
    SET_EXPORT_DOCUMENTS_URL: 'HAULING STATISTIC TYPES SET EXPORT DOCUMENTS URL',
    CLEAR_EXPORT_DOCUMENTS_URL: 'HAULING STATISTIC TYPES CLEAR EXPORT DOCUMENTS URL',
    ON_DATE_CHANGE: 'HAULING STATISTIC TYPES ON DATE CHANGE',
};
